import AuthClient from './auth-client';
import AppClient from './app-client';

export const authClient = new AuthClient();
export const appClient = new AppClient();
